import { RetryLink } from '@apollo/client/link/retry';
import { getMainDefinition } from '@apollo/client/utilities';

const minDelay = 0;

export const backoffMultiplier = 1000;

export const jitterMaxMultiplier = 2;

export const retryLink = new RetryLink({
  attempts: (count, operation) => {
    // only called when network error happens
    const main = getMainDefinition(operation.query);

    if (main.kind === 'OperationDefinition') {
      // only retry queries once. Most of the queries are polling which aren't super important
      if (main.operation === 'query' && count === 1) {
        return true;
      } else if (main.operation === 'mutation' && count <= 3) {
        return true;
      }
    }

    return false;
  },

  delay: (count) => {
    const backoff = count * backoffMultiplier;
    // Use same jitter as default implementation: everything between min and twice the backoff
    const maxDelay = backoff * jitterMaxMultiplier;
    const delay = Math.floor(Math.random() * (maxDelay - minDelay + 1)) + minDelay;

    return delay;
  },
});
